import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getThemesFlat(
    { subjectSlug, showUnpublished = undefined, rootId = undefined, depth = undefined }: any
) {
    const { apiGetThemesFlat } = apiConfig.getStaticUrls();

    return getFetch(apiGetThemesFlat, { subjectSlug, showUnpublished, rootId, depth });
}
